import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, Text } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import Image from "next/image";
import styles from "./stats-section.module.css";
export var StatsSection = function(blok) {
    var heading = blok.heading, stats = blok.stats, image = blok.image, carTotal = blok.carTotal, trackingEventName = blok.trackingEventName;
    var trackEvent = useAnalytics().trackEvent;
    return /*#__PURE__*/ _jsxs(Wrapper, _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        className: {
            inner: styles.statsWrapper
        },
        isSlim: true,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.carSectionTitle,
                element: "h2",
                fontSizeFixed: "xl",
                fontWeight: "bold",
                children: heading
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.stats,
                children: [
                    stats.map(function(stat, idx) {
                        return /*#__PURE__*/ _jsx("div", {
                            className: styles.stat,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles.statInner,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: styles.statHeading,
                                        children: stat.heading
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: styles.statSubHeading,
                                        fontSizeFixed: "m",
                                        fontWeight: "bold",
                                        children: stat.subheading
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSizeFixed: "m",
                                        children: stat.body
                                    })
                                ]
                            })
                        }, "car-point-".concat(idx + 1));
                    }),
                    (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/ _jsx("div", {
                        className: styles.statImage,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: image === null || image === void 0 ? void 0 : image.filename,
                            alt: (image === null || image === void 0 ? void 0 : image.alt) || "Side profile of a car",
                            layout: "responsive",
                            width: 1400,
                            height: 597,
                            quality: 100
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Primary, {
                element: "a",
                href: "/used-cars",
                onClick: function() {
                    if (trackingEventName) {
                        trackEvent({
                            eventName: trackingEventName,
                            data: {
                                event: {
                                    name: "click",
                                    category: "button",
                                    label: "Browse all cars"
                                }
                            },
                            type: TrackingEventTypes.ADOBE
                        });
                    }
                },
                classNames: {
                    button: styles.statsButton
                },
                children: "Browse ".concat(carTotal !== null && carTotal !== void 0 ? carTotal : "all", " cars")
            })
        ]
    }));
};
export default StatsSection;
